import * as React from 'react';
import { Typography } from '@catapultsports/referee-react';
import clsx from 'clsx';
import styles from './settings-menu.module.css';
interface SettingsTitleProps {
    title: string;
    description?: string;
    showBottomBorder?: boolean;
}

export const SettingsTitle: React.FunctionComponent<SettingsTitleProps> = ({
    title,
    description,
    showBottomBorder = true,
}) => (
    <div
        className={clsx(styles['settings-title__container'], showBottomBorder ? styles['settings-title__border'] : '')}
    >
        <Typography className={styles['settings-title__title']} testId="setting-title" variant="heading-3">
            {title}
        </Typography>
        {description ? <Typography variant="body-1">{description}</Typography> : null}
    </div>
);
